/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import organizationPlaceholder from '../../../assets/images/icons/organization.svg';
import DetailsCard from '../../common/details.card/details.card';

const OrganizationDetailsCard = ({ organization: { name, organizationType, timezone, country } = {} }) => {
  const content = [
    { label: 'Name', value: name },
    { label: 'Timezone', value: timezone },
    { label: 'Organization Type', value: organizationType },
    { label: 'Country', value: country }
  ];

  return <DetailsCard picture={organizationPlaceholder} content={content} cardId="organization-details-card" />;
};

OrganizationDetailsCard.propTypes = {
  organization: PropTypes.object.isRequired
};

export default OrganizationDetailsCard;
